export default "__VITE_ASSET__Bl2sNta$__"